import React from 'react';
import { Alert } from '@mui/material';

interface InspectionReportFormAlertsProps {
  restoredFromDraft: boolean;
  mediaCount: number;
  submitted: boolean;
  errorMessage: string | null;
  manufacturersError: boolean;
  onClearError: () => void;
}

const InspectionReportFormAlerts: React.FC<InspectionReportFormAlertsProps> = ({
  restoredFromDraft,
  mediaCount,
  submitted,
  errorMessage,
  manufacturersError,
  onClearError,
}) => (
  <>
    {restoredFromDraft && mediaCount > 0 && (
      <Alert severity="info" sx={{ mb: 2 }}>
        Your previous draft was restored, including {mediaCount} media file{mediaCount === 1 ? '' : 's'}.
      </Alert>
    )}

    {restoredFromDraft && mediaCount === 0 && (
      <Alert severity="info" sx={{ mb: 2 }}>
        Your previous draft was restored from this device.
      </Alert>
    )}

    {submitted && (
      <Alert severity="success" sx={{ mb: 2 }}>
        Report updated successfully!
      </Alert>
    )}

    {manufacturersError && (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Manufacturer lists could not be loaded. Dropdowns may be empty; try refreshing the page.
      </Alert>
    )}

    {errorMessage && (
      <Alert severity="error" sx={{ mb: 2 }} onClose={onClearError}>
        {errorMessage}
      </Alert>
    )}
  </>
);

export default InspectionReportFormAlerts;
